import { Box } from "theme-ui";

export default function HelpIcon(props) {
  return (
    <Box
      as="svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13" cy="13" r="12" stroke="#009CDA" strokeWidth="2" />
      <path
        d="M10 10C10 8.34315 11.3431 7 13 7C14.6569 7 16 8.34315 16 10C16 11.313 15.1565 12.4289 13.9819 12.8356C13.46 13.0163 13 13.4477 13 14V16M13 18V20"
        stroke="#009CDA"
        strokeWidth="2"
      />
    </Box>
  );
}
